export default __webpack_public_path__ + "static/view-thumb-268ca330556cec270a8e9c16ae7226c4.jpg";